import React, { FC, Fragment, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ListItemText, ListItemIcon, Menu, MenuItem } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';

import * as Links from 'Links';
import { CustomSVG } from 'components';

const FunctionTemplate: FC = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  function handleOpen(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <Fragment>
      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleClose}>
        <MenuItem onClick={handleClose} dense component={Links.PostCreate}>
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="New Post" />
        </MenuItem>
        <MenuItem onClick={handleClose} dense component={Links.Share}>
          <ListItemIcon>
            <CustomSVG name="share" size={20} />
          </ListItemIcon>
          <ListItemText primary="Quick Share" />
        </MenuItem>
      </Menu>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleOpen}
        startIcon={<CreateIcon fontSize="small" />}>
        {t('common:compose')}
      </Button>
    </Fragment>
  );
};

export default FunctionTemplate;
